import React, { useState, useEffect } from 'react';
import ServerSideService from '../../../../services/server-side-service/server-side-service';

import './black-label.scss';
import { NewAnalyticsService } from '../../../../services/new-analytics-service/new-analytics-service';
import { useAnalytics } from '../../../../hooks/use-analytics';
export interface BlackLabelProps {
    mobileBackgroundImage: string;
    desktopBackgroundImage: string;
    title: string;
    bodyContent: string;
    buttonText: string;
    buttonLink: string;
}

export const BlackLabel: React.FC<BlackLabelProps> = ({
    mobileBackgroundImage,
    desktopBackgroundImage,
    title,
    bodyContent,
    buttonText,
    buttonLink,
}) => {
    const [isMobile, setMobile] = useState<boolean>(
        ServerSideService.isClientSide()
            ? window.matchMedia('(max-width: 767px)').matches
            : false
    );
    const handleWindowResize = () => {
        setMobile(
            ServerSideService.isClientSide()
                ? window.matchMedia('(max-width: 767px)').matches
                : false
        );
    };
    const [fireEvents] = useAnalytics();
    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    return (
        <div className="black-label-container">
            <div
                className="black-label-main"
                style={{
                    backgroundImage: `url(${
                        isMobile
                            ? mobileBackgroundImage
                            : desktopBackgroundImage
                    })`,
                }}
            >
                <div className="bl-content">
                    <span className="card-display-title">{title}</span>
                    <p className="card-display-body">{bodyContent}</p>

                    <a
                        className="card-display-button"
                        href={buttonLink}
                        aria-label={buttonText}
                        onClick={() => {
                            NewAnalyticsService.fireReferralExitEventBasedOnUrl(
                                buttonLink,
                                fireEvents
                            );
                        }}
                    >
                        {buttonText}{' '}
                        <span className="fds-icon fds-font--ford-icons__chevron-right fds-color__text--white"></span>
                    </a>
                </div>
            </div>
        </div>
    );
};
